import InputGeneric from './InputGeneric';

export default class InputNumber extends InputGeneric {
    init() {
        super.init();
    }
}
